import * as React from "react"

export const contactDetails = (customerSupportText: string): JSX.Element => (
  <div>
    {customerSupportText != "" ? <div dangerouslySetInnerHTML={{__html: customerSupportText}} /> : <></>}
  </div>
)

{/* TH: Added to styleguide! */}
